import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import Logo from "../assets/Logo.png";
import { NavLink } from "react-router-dom";
import "../utils/effectCSS/Effects.css";

const CustomNavbar = () => {
  return (
    <Navbar
      expand="lg"
      className="bg-navbar-color"
      style={{
        padding: "5px",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        backdropFilter: "blur(3px)",
        width: "100%",
        position: "fixed",
        zIndex: 1000,
      }}
    >
      <Container>
        <Navbar.Brand as={NavLink} to={"/"} >
          <img
            src={Logo}
            alt="Logo"
            style={{
              height: "60px",
              borderRadius: "3px",
            }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="transparent" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto gap-3">
            <Nav.Link as={NavLink} to={"/"} >
              <span className="custom-nav-link" >Home</span>
              
            </Nav.Link>
            <NavDropdown
              className="border border-0"
              title={<span className="custom-nav-link" >Solutions</span>}
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item as={NavLink} to={"/id&a"}>
                Identity Governance and Administration
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to={"/access-m"}>
                Access Management
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to={"/m-fa"}>
                Multi-Factor Authentication
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to={"/pam"}>
                Privilege Access Management
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown
              title={<span className="custom-nav-link" >Services</span>}
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item as={NavLink} to={"/iam-imp"}>
                IAM Implementation Services
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to={"/iam-adv"}>
                IAM Advisory Services
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to={"/iam-man"}>
                IAM Managed Services
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to={"/contact"} >
              <span className="custom-nav-link" >Contact Us</span>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
